import React, { useMemo } from 'react';
import * as S from './styles';
import { faImage, faEraser,faPlay } from '@fortawesome/free-solid-svg-icons';
import { DateInput } from '../../../components/interface/DateInput';
import Table from '../../../components/interface/Tabela';
import ActionButtons from '../../../components/interface/ActionButtons';
import { Modal } from '../../../components/interface/Modal';
import { Entrega, RelatoriosEntregasViewProps } from './types';
import Select2, { SelectOption } from '../../../components/Layout/Select2';
import { DefaultTheme } from 'styled-components';


const RelatoriosEntregasContent: React.FC<RelatoriosEntregasViewProps> = ({
  entregas,
  loading,
  error,
  formData,
  selectedEntrega,
  showModal,
  entregadores,
  handleInputChange,
  handleSearch,
  handleClear,
  handleViewImage,
  closeModal
}) => {
  const columns = [
    { key: 'codigo' as keyof Entrega, header: 'Código', width: '80px', filterable: true },
    {
      key: 'data' as keyof Entrega,
      header: 'Data',
      filterable: true,
      render: (item: Entrega) => {
        const date = new Date(item.data);
        return date.toLocaleDateString('pt-BR');
      }
    },
    { key: 'chavenotafiscal' as keyof Entrega, header: 'Chave da Nota Fiscal', filterable: true },
    { key: 'nomeusuario' as keyof Entrega, header: 'Entregador', filterable: true },
    {
      key: 'imagem' as keyof Entrega,
      header: 'Imagem',
      render: (item: Entrega) => {
        return item.imagem ? (
          <S.ActionLink onClick={() => handleViewImage(item)}>
            Visualizar
          </S.ActionLink>
        ) : (
          <span>Sem imagem</span>
        );
      }
    },
    {
      key: 'status' as keyof Entrega,
      header: 'Status',
      filterable: true,
      render: (item: Entrega) => item.status || 'Pendente'
    },
  ];

  const entregadoresOptions: SelectOption[] = entregadores.map(e => ({
    value: e.codigousuario,
    label: e.nomeusuario
  }));
  const selectedEntregadorOption = formData.usuario
    ? entregadoresOptions.find(option => Number(option.value) === formData.usuario) || null
    : null;
  const actions = useMemo(() => [
      {
        icon: faPlay,
        onClick: handleSearch,
        title: 'Buscar',
        children: 'Buscar',
        disabled: loading,
        backgroundColor: (theme: DefaultTheme) => theme.primaryColor
      },
      {
        icon: faEraser,
        onClick: handleClear,
        title: 'Limpar',
        children: 'Limpar',
        backgroundColor: '#4dc9c9'
      }
  ], [handleSearch, loading, handleClear]);
  return (
    <S.RelatoriosContainer>
      <S.RelatoriosContent>
        <S.FilterContainer>
          <S.FilterGroup>
            <DateInput
              id="dataInicio"
              setValue={(value) => handleInputChange('dataInicio', value)}
              initialValue={formData.dataInicio}
              hasLabel={true}
              label="Data Início"
              required={true}
              labelPosition="left"
            />
            <DateInput
              id="dataFim"
              setValue={(value) => handleInputChange('dataFim', value)}
              initialValue={formData.dataFim}
              hasLabel={true}
              label="Data Fim"
              required={true}
              labelPosition="left"
            />
          </S.FilterGroup>
        </S.FilterContainer>
        <S.FilterContainer>
          <Select2
                id="usuario"
                options={[{ value: '', label: 'Selecione um entregador' }, ...entregadoresOptions]}
                value={selectedEntregadorOption}
                maxVisibleOptions={100}
                onChange={(option: SelectOption) => handleInputChange('usuario', option.value ? Number(option.value) : null)}
                placeholder="Selecione um entregador"
              />
        </S.FilterContainer>
        <S.ButtonContainer>
            <ActionButtons
              buttons={actions}
            />
          </S.ButtonContainer>
        {error && (
          <S.ErrorContainer>
            {error}
          </S.ErrorContainer>
        )}

        <S.TableContainer>
          {entregas.length > 0 ? (
            <Table
              data={entregas}
              columns={columns}
              exportable={true}
            />
          ) : (
            <p style={{ textAlign: 'center', padding: '20px' }}>
              {loading ? 'Carregando...' : 'Nenhuma entrega encontrada'}
            </p>
          )}
        </S.TableContainer>
      </S.RelatoriosContent>

      {showModal && selectedEntrega && (
        <Modal
          isOpen={true}
          onClose={closeModal}
          title={`Imagem da Entrega #${selectedEntrega.codigo}`}
          headerIcon={faImage}
        >
          <S.ModalContainer>
            {selectedEntrega.imagem ? (
              <S.ModalImage src={selectedEntrega.imagem} alt="Imagem da entrega" />
            ) : (
              <S.ImagePlaceholder>
                Sem imagem disponível
              </S.ImagePlaceholder>
            )}
          </S.ModalContainer>
        </Modal>
      )}
    </S.RelatoriosContainer>
  );
};

export default RelatoriosEntregasContent;
